/*
Things this page can cover:
High level, core contributor on the team that created this site builder.
Talk about Inc
(video showing inc, Contentful making a change and seein it live on the preview site. This shows the preview button too.)

Talk about different parts of site:
- Hubspot form builder
- Contentful deploy app
- Preview site
- Image focal point tool
- horizontal scroller buttons
- /progress
- /blog
- CMS Spacing system
- Covid driving
- Eliminate widows
- Product availability
- Site performance/SEO work nearly brought Root to page 1 on Google when someone searches "Car insurance".
*/

import React from "react"
import Seo from "../components/seo"
import StandardLayout from "../components/highlighted-work/standard-layout"
import { H1, H2, Li, P1, ToolingText } from "../components/highlighted-work/text"
import { StaticImage } from "gatsby-plugin-image"
import formBuilderVideoOne from '../images/hubspot-form-builder/hubspot-form-generator-overview.mp4';
import formBuilderLooping from '../images/hubspot-form-builder/hubspot-form-builder-looping.mp4';

export default function RootInsuranceMartech() {
  return (
    <>
      <Seo title="Zac Remboldt | Root Insurance Co." />
      <StandardLayout>
        <H1>Marketing tech at Root Insurance Co.</H1>

        <section>
          <H2>Site builder | inc.joinroot.com</H2>
          <ToolingText>Primary tools: Contentful, Gatsby/React, AWS CloudFront</ToolingText>
          <P1>One project at Root that I'm most proud of is my work developing a page creation system which powers inc.joinroot.com. The system allows designers and copywriters to build, publish, and deploy web pages without engineering support. This project greatly improved Root's ability to push out new content and iterate, taking a process that used to take ~2 weeks of engineering's time, down to now ~45 minutes of marketing's time! I built the majority of this system from the ground up over roughly a 4 month period.</P1>
          <StaticImage
            src="../images/root-marketing-tech/inc-cms.png"
            alt="Screenshot of the inc.joinroot.com site and Contentful CMS"
          />
          <P1>Work involved in this project:</P1>
          <ul>
            <Li>Designed a Contentful content model of fairly generic pieces that can be combined in a variety of ways. This brings a ton of flexibility to the way designers are able to mix and match our component building blocks.</Li>
            <Li>Developed the entire system of React components that are the building blocks for the site. This includes a series of highly configurable page section components, a typographic system, colors, buttons, global elements, a spacing control system, etc.</Li>
            <Li>Worked in close communication with designers sharing progress along the way.</Li>
            <Li>Obsessed over code quality, file organization, naming conventions, and clean abstractions, ensuring that both the future developer experience and the page authoring experience are intuitive and enjoyable.</Li>
            {/* <Li>Created a Contentful Deploy App which allows content authors to deploy the site to production from Contentful. It can easily be configured to work with different sites. Talks to RooterBot to trigger a Buildkite deploy.</Li> */}
          </ul>
          <P1>Oh, and did I mention the site is fast?!</P1>
          <StaticImage
            src="../images/root-marketing-tech/lighthouse-score.jpg"
            alt="Lighthouse showing a performance score of 100 for inc.joinroot.com"
          />
        </section>

        <section>
          <H2>HubSpot Form Builder</H2>
          <ToolingText>Primary tools: HubSpot API, Node, GraphQL, Gatsby/React, Contentful</ToolingText>
          <P1>Creating React forms that talk to HubSpot (a marketing lead gen tool) was a common request our team would receive from marketing, each form taking roughly a week to complete. To solve this I built a tool that allows marketing to do it on their own. They create their form using the HubSpot UI, then paste the form id into Contentful (our CMS) wherever they want the form to render, click deploy, and 3 minutes later the new form is live on the site!</P1>
          <P1>Interesting things to note:</P1>
          <ul>
            <Li>The GET request used to build the forms happens at build time, not on the client. When the user requests the page the form is already part of it (no layout shift like you'd see with an embedded form). The resulting form is made up of components from Root's own React component library.</Li>
            <Li>I built this as a plugin that can be easily reused across our Gatsby sites.</Li>
          </ul>
          <P1>Below you can see how easy it is to build your form within HubSpot's drag-and-drop editor and then you see those changes reflected on the Root marketing site. 👇</P1>
          <div className="video-container">
            <video autoPlay loop muted playsInline>
              <source src={formBuilderLooping} type="video/mp4" />
            </video>
          </div>
          <P1>Below is one of the videos I created to help communicate the feature internally at Root (unmute to hear the description).</P1>
          <div className="video-container">
            <video controls>
              <source src={formBuilderVideoOne} type="video/mp4" />
            </video>
          </div>
        </section>


        {/* <H2>Contentful deploy app</H2>
        <H2>CMS content preview site</H2>
        <H2>Image focal point tool</H2>
        <H2>horizontal scroller buttons</H2>
        <H2>/progress</H2>
        <H2>/blog</H2>
        <H2>CMS Spacing system</H2>
        <H2>Covid driving</H2>
        <H2>Eliminate widows</H2>
        <H2>Product availability</H2>
        <H2>Site performance/SEO work nearly brought Root to page 1 on Google when someone searches "Car insurance".</H2> */}
      </StandardLayout>
    </>
  )
}
